export enum DeliveryTypes {
    DELIVERY = "LIV",
    RECOVERY = "REP"
}
